import React, { ReactNode, useState } from "react";

interface Props {
  children: ReactNode;
}

function ErrorBoundary({ children }: Props) {
  const [hasError, setHasError] = useState(false);

  if (hasError) {
    return <h1>Sorry.. there was an error</h1>;
  }

  try {
    return <>{children}</>;
  } catch (error) {
    console.error("Uncaught error:", error);
    setHasError(true);
    return <h1>Sorry.. there was an error</h1>;
  }
}

export default ErrorBoundary;
